module.exports = __webpack_public_path__ + "typicons.a509074c88f07e40a8d2.eot";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/node_modules/typicons.font/src/font/typicons.eot
// module id = ../../../../typicons.font/src/font/typicons.eot
// module chunks = styles